import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, CanActivate } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Observable, BehaviorSubject, throwError } from 'rxjs';

import { Storage } from '@ionic/storage';
import { Token } from '../entities/token';
import { TokenResponse } from '../entities/token';
import { Authority } from '../entities/authority';
import { environment } from 'src/environments/environment';
import { NavController } from '@ionic/angular';
import { UserService } from './user.service';

@Injectable({
	providedIn: 'root'
})
export class AuthService implements CanActivate {
	authSubject  =  new  BehaviorSubject(false);
	TOKEN: string;
	REFRESH_TOKEN: string;
	AUTHORITIES: string[];
	USERNAME: string;
	CHANGEPASSWORD: string;
	ID: string;
	ID_HERMANO: string;

	constructor(
		private  httpClient:  HttpClient, 
		private  storage:  Storage, 
		public router: Router,
		private navController: NavController,
		private userSrv: UserService
	){
		this.TOKEN = null;
		this.REFRESH_TOKEN = null;
		this.AUTHORITIES = [];
		this.USERNAME =  null;
		this.CHANGEPASSWORD = null;
		this.ID = null;
		this.ID_HERMANO = null;
	    
		/*
		console.log("Constructor auth");
		this.storage.get('ACCESS_TOKEN').then( res => {
			this.TOKEN = res;
			console.log("Token Leido Storage");
		});

		this.storage.get('USERNAME').then( res => {
			this.USERNAME = res;
		});

		this.storage.get('REFRESH_TOKEN').then( res => {
			this.REFRESH_TOKEN = res;
		});
		*/
	}
	
	login(user: Token): Observable<TokenResponse> {
		return this.httpClient.post(`${environment.baseURL}login`, user).pipe(
			tap ((res: TokenResponse) => {
				if (res.access_token) {
					console.log('Token Solicitado y Guardado en Storage');
					this.setStorage('ACCESS_TOKEN', res.access_token);
					this.setStorage('REFRESH_TOKEN', res.refresh_token);
					this.setStorage('USERNAME', res.username);
					this.setStorage('CHANGEPASSWORD', res.changepassword);
					this.setStorage('ID', res.id);
					this.setStorage('ID_HERMANO', res.id_hermano);

					// this.storage.set('ACCESS_TOKEN', res.access_token);
					// this.storage.set('REFRESH_TOKEN', res.refresh_token);

					this.TOKEN          = res.access_token;
					this.REFRESH_TOKEN  = res.refresh_token;
					this.USERNAME 		= res.username;
					this.CHANGEPASSWORD = res.changepassword;
					this.ID = res.id;
					this.userSrv.getUser(this.ID).subscribe(data=> {
						this.setStorage('ID_HERMANO',data.id_hermano);
						this.ID_HERMANO = data.id_hermano;
					})
					this.authSubject.next(true);
				}
			})
		);
	}

	refreshToken(): Observable<any> {
		let body = {
			grant_type: 'refresh_token',
			refresh_token: this.REFRESH_TOKEN,
			client_secret: 'secret',
			client_id: 'saturno-api3'
		};

		console.log("Ask for a new refresh_token");

		return this.httpClient.post(`${environment.baseURL}login`, body).pipe(tap (
			(res: any) => {
				if (res.access_token) {
					this.authSubject.next(true);
				}else{
					console.log("No token" )
				}
			},
			error =>{
				console.log("Error getting refresh token. " + error)
			})
		);
	}

	getAuthorities(): Observable<Array<Authority>> {
		return this.httpClient.get(`${environment.baseURL}uaa/authorities`).pipe(
			tap((authority: Array<Authority>) => {
			})
		);
	}

	hasPermission(permission : string):boolean{
		return (this.AUTHORITIES.indexOf(permission) !== -1)
	}

	async logout() {
		await this.storage.clear();
		this.TOKEN = null;
		this.REFRESH_TOKEN = null;
		this.AUTHORITIES = [];
		this.authSubject.next(false);
	}

	canActivate(): boolean {
		if (!this.authSubject.getValue()) {
			this.router.navigate(['login']);
			return false;
		}
		return true;
	}

	isLogged(): boolean {
		return this.authSubject.getValue();
	}

	getToken() {
		console.log("Get Token");
		return this.TOKEN;

	}

	setToken(token) {
		this.TOKEN      = token;
		this.setStorage('ACCESS_TOKEN', token);

		if( token == null){
			this.logout();
			//location.reload();
			this.navController.navigateRoot(['login']);
		}

		
	}

	setRefreshToken(refreshToken) {
		this.REFRESH_TOKEN = refreshToken;
		this.setStorage('REFRESH_TOKEN', refreshToken);
	}

	getAuthoritys(): string[] {
		return this.AUTHORITIES;
	}

	getChangePass(): boolean {
		return (this.CHANGEPASSWORD == "true") ;
	}

	//getStorage(settingName): Promise<string>{
	//	return this.storage.get(settingName);
	//}

	setStorage(settingName,value){
		this.storage.set(settingName,value);
	}
}
